var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-page crowdloan-page scroll-content"},[_c('div',{staticClass:"empty-bg"},[_c('img',{attrs:{"src":require("@/static/images/empty-data.png"),"alt":""}}),_c('p',[_vm._v(" "+_vm._s(_vm.$t('tip.comingSoon'))+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }